// AUTO-GENERATED by tools/generate-world3.mjs. Do not edit by hand.
// Regenerate with: node tools/generate-world3.mjs
import type { LevelDef } from '@tessera/engine';

export const WORLD_3_GENERATED: LevelDef[] = [
  // d*=4  branching=15.06  D=0.107
  {
    id: 'w3-l01',
    world: 3,
    index: 1,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: -2, r: 2 }, color: 0 },
    { coord: { q: 0, r: 3 }, color: 1 },
    { coord: { q: 0, r: 0 }, color: 0 },
    { coord: { q: 0, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -1 }, color: 0 },
    { coord: { q: 1, r: -3 }, color: 1 },
    { coord: { q: 3, r: 0 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=4  branching=26.00  D=0.241
  {
    id: 'w3-l02',
    world: 3,
    index: 2,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: 1, r: 0 }, color: 1 },
    { coord: { q: -1, r: 0 }, color: 1 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 3 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 1 }, color: 0 },
    { coord: { q: -2, r: 1 }, color: 1 },
    ],
  },
  // d*=4  branching=25.52  D=0.241
  {
    id: 'w3-l03',
    world: 3,
    index: 3,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: 0, r: -3 }, color: 0 },
    { coord: { q: 2, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: 0 }, color: 1 },
    { coord: { q: 0, r: -1 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 0 },
    ],
  },
  // d*=4  branching=25.61  D=0.252
  {
    id: 'w3-l04',
    world: 3,
    index: 4,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: -1, r: -1 }, color: 0 },
    { coord: { q: 1, r: 0 }, color: 0 },
    { coord: { q: 0, r: 0 }, color: 1 },
    { coord: { q: -1, r: 1 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 1 },
    ],
  },
  // d*=4  branching=28.57  D=0.264
  {
    id: 'w3-l05',
    world: 3,
    index: 5,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: 0 }, color: 0 },
    { coord: { q: -3, r: 2 }, color: 1 },
    { coord: { q: -1, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 1 }, color: 1 },
    { coord: { q: 3, r: -2 }, color: 0 },
    { coord: { q: -1, r: 2 }, color: 1 },
    { coord: { q: 1, r: -3 }, color: 0 },
    ],
  },
  // d*=4  branching=30.04  D=0.287
  {
    id: 'w3-l06',
    world: 3,
    index: 6,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 6 },
    tiles: [
    { coord: { q: 1, r: 2 }, color: 1 },
    { coord: { q: -2, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 0, r: 1 }, color: 0 },
    { coord: { q: 0, r: -1 }, color: 0 },
    { coord: { q: 1, r: -2 }, color: 1 },
    { coord: { q: 0, r: 0 }, color: 1 },
    ],
  },
  // d*=5  branching=17.45  D=0.118
  {
    id: 'w3-l07',
    world: 3,
    index: 7,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: -1, r: -1 }, color: 1 },
    { coord: { q: -3, r: 2 }, color: 0 },
    { coord: { q: -1, r: 3 }, color: 1 },
    { coord: { q: 0, r: 3 }, color: 0 },
    { coord: { q: -3, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -1, r: -2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 1 }, color: 1 },
    { coord: { q: -1, r: 0 }, color: 2 },
    { coord: { q: -3, r: 1 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 0 },
    ],
  },
  // d*=5  branching=21.76  D=0.234
  {
    id: 'w3-l08',
    world: 3,
    index: 8,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: 0, r: 1 }, color: 1 },
    { coord: { q: -1, r: 1 }, color: 0 },
    { coord: { q: 2, r: 0 }, color: 1 },
    { coord: { q: -2, r: 3 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: -3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 1, r: -2 }, color: 2 },
    { coord: { q: -2, r: -1 }, color: 0 },
    { coord: { q: 3, r: -2 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=5  branching=22.45  D=0.240
  {
    id: 'w3-l09',
    world: 3,
    index: 9,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: -1, r: -1 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 1, r: 0 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 0, r: -3 }, color: 1 },
    { coord: { q: -3, r: 3 }, color: 0 },
    { coord: { q: 0, r: 0 }, color: 2 },
    { coord: { q: 0, r: -1 }, color: 2 },
    { coord: { q: -1, r: -2 }, color: 0 },
    { coord: { q: 1, r: 1 }, color: 1 },
    { coord: { q: 2, r: -1 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    ],
  },
  // d*=5  branching=26.26  D=0.269
  {
    id: 'w3-l10',
    world: 3,
    index: 10,
    radius: 3,
    holes: [],
    objective: { kind: 'clear', moveBudget: 7 },
    tiles: [
    { coord: { q: 0, r: 0 }, color: 2, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -3 }, color: 2 },
    { coord: { q: 0, r: 3 }, color: 0, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: -2, r: 0 }, color: 0 },
    { coord: { q: 3, r: -1 }, color: 0 },
    { coord: { q: 0, r: 1 }, color: 1 },
    { coord: { q: 0, r: 2 }, color: 1, state: { kind: 'charged', chainDepth: 1 } },
    { coord: { q: 2, r: -1 }, color: 0 },
    { coord: { q: 0, r: -1 }, color: 1 },
    { coord: { q: 3, r: -3 }, color: 2 },
    ],
  },
];
